import { render, staticRenderFns } from "./re-fabric-text.vue?vue&type=template&id=16536ea5"
import script from "./re-fabric-text.vue?vue&type=script&lang=ts"
export * from "./re-fabric-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports